export enum ROOMCLOUD_CHANNEL_MANAGER {
  MISTER_BOOKING = 'MISTER_BOOKING',
  THAIS = 'THAIS',
}

export type ChannelManagerValue = ChannelManager | ROOMCLOUD_CHANNEL_MANAGER;

export enum ChannelManager {
  NONE = 'NONE',
  D_EDGE = 'DEDGE',
  SITEMINDER = 'SITEMINDER',
  RESERVIT = 'RESERVIT',
  CUBILIS = 'CUBILIS',
  TRAVELCLICK = 'TRAVELCLICK',
  ROOMCLOUD = 'ROOMCLOUD',
  MEWS = 'MEWS',
  DERBYSOFT = 'DERBYSOFT',
}

export const CHANNEL_MANAGER_LABELS = [
  { manager: ChannelManager.NONE, label: 'None' },
  { manager: ChannelManager.D_EDGE, label: 'D-Edge' },
  { manager: ChannelManager.SITEMINDER, label: 'Siteminder' },
  { manager: ChannelManager.RESERVIT, label: 'Reservit' },
  { manager: ChannelManager.CUBILIS, label: 'Cubilis' },
  { manager: ChannelManager.TRAVELCLICK, label: 'Travelclick' },
  { manager: ChannelManager.ROOMCLOUD, label: 'Roomcloud' },
  { manager: ChannelManager.MEWS, label: 'Mews' },
  { manager: ChannelManager.DERBYSOFT, label: 'Derbysoft' },
] as const;
